import { render, staticRenderFns } from "./isvpsVideoDetail.vue?vue&type=template&id=36e6d110&scoped=true&"
import script from "./isvpsVideoDetail.vue?vue&type=script&lang=js&"
export * from "./isvpsVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./isvpsVideoDetail.vue?vue&type=style&index=0&id=36e6d110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e6d110",
  null
  
)

export default component.exports